module.exports = __webpack_public_path__ + "img/icon17.6caa8147.png";